import { Grid, Box } from '@material-ui/core';
import { Captions, ShortBody } from 'components/Typography';
import styled from 'styled-components';

export const ErrorCaption = styled(Captions)`
  &&& {
    margin-bottom: 0px;
    text-align: start;
  }
`;
export const AlignedGrid = styled(Grid)`
  align-self: center;
`;
export const StyledGrid = styled(Grid)`
  && {
    margin-bottom: 68px;
    align-self: center;
  }
`;
export const StyledBox = styled(Box)`
  height: '10px';
`;

export const PositionedShortBody = styled(ShortBody)`
  && {
    margin-bottom: 0px;
    position: relative;
    top: -25px;
  }
`;
